<template>
  <div>
    <div
      layout="column"
      class="full-width pl-0"
    >
      <div
        layout="row"
        layout-align="start center"
        class="full-width"
      >
        <v-subheader v-if="isActivity">
          Interns
        </v-subheader>
        <v-subheader v-else-if="isTraining || isIntroductionDay">
          Participants
        </v-subheader>
        <v-subheader v-else>
          Visitors
        </v-subheader>
        <span flex />
        <template v-if="!isPastTraining">
          <v-btn
            v-if="canParticipate(session)"
            @click="participate(session)"
          >
            I want to participate
          </v-btn>
          <v-btn
            v-if="canUnparticipate(session)"
            @click="participate(session)"
          >
            I want to unregister
          </v-btn>
        </template>
      </div>
      <div
        layout="column"
        layout-align="start start"
        flex
        style="padding-left: 15px"
      >
        <ul
          v-if="session.session_visitor && session.session_visitor.length"
          class="mb-3"
        >
          <li
            v-for="v in session.session_visitor"
            :key="'visitor_'+v.id"
          >
            <v-icon
              v-if="isQueued(v, session, session.session_visitor)"
              class="mr-1"
              small
              title="In the queue"
            >
              mdi-human-queue
            </v-icon>
            <span>{{ v.user.firstname }} {{ v.user.lastname }}</span>
            <span
              v-if="amIInside && v.trainer_id"
              :class="{'is-me': Auth.user.id == v.trainer_id}"
            >(with {{ experts[v.trainer_id] ? `${experts[v.trainer_id].firstname} ${experts[v.trainer_id].lastname}`: '?' }})</span>
            <span
              v-if="isActivity && !v.trainer_id"
            >(waiting for an expert)</span>
          </li>
        </ul>
        <div
          v-if="isPastTraining && (canParticipate(session) || canUnparticipate(session))"
          class="grey--text font-italic"
          v-text="params.training_close_message"
        />
      </div>
    </div>
  </div>
</template>
<script>
import sessionsMixin from '@/mixins/sessions'
import globalMixin from '@/mixins/global'
import Consts from '@/consts'
import Params from '@/api/params'
import moment from 'moment'
import Auth from "@/plugins/auth"

export default {
	mixins: [sessionsMixin, globalMixin],
	props: {
		session: {
			type: Object,
			required: true,
			default: () => {}
		}
	},
	data() {
		return {
			params: {
				nb_days_training_close: 7,
				training_close_message: 'For organizational reasons it is impossible to register for the training via the site, if the deadline of one week before the training has passed. If you are interested in participating in this training, you can nevertheless contact the SNJ team at animateur.specialise@snj.lu or call 247-86496.'
			},
      Auth
		}
	},
	computed: {
    isTraining() {
      if (parseInt(this.session.session_type) == Consts.FREELANCES_TRAINING || parseInt(this.session.session_type) == Consts.FREELANCES_REFRESH_TRAINING) {
        return true;
      }
      return false;
		},
    isIntroductionDay() {
      return parseInt(this.session.session_type) == Consts.INTRODUCTION_DAY
    },
		isActivity() {
      if (parseInt(this.session.session_type) == Consts.ACTIVITY) {
        return true;
      }
      return false;
		},
		isPastTraining(){
			if(!this.isTraining && !this.isIntroductionDay){
				return false
			}

			let past = false

			this.session.dates.forEach(d => {
				if(moment(d.start).isBefore(moment().add(this.params.nb_days_training_close, 'days'))){
					past = true
				}
			})

			return past
		},
    experts() {
      const experts = {}
      this.session.session_visitor.forEach(v => {
        if(v.trainer_id) {
          experts[v.trainer_id] = this.session.trainers.find(t => t.id == v.trainer_id)
        }
      })
      return experts
    },
    amIInside() {
      return !this.isTrainer || !! this.session.trainers.find(t => t.id == Auth.user.id)
    }
	},
	mounted() {
    this.loadUser()
		Params.getList('params').then(res => {
			res.data.forEach(l => {
				this.params[l.name] = l.value
			})
		})
	},
}
</script>
<style scoped>
	.v-subheader {
		padding: 0 10px;
	}

  .is-me {
    color: tomato;
    font-size: 1.2rem;
    font-weight: bold;
  }
</style>
